<template>
  <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 0.0195312H0V4.53612H1.01027V22.0195H20.9897V4.53612H22V0.0195312ZM1.28906 1.30859H20.7109V3.24706H1.28906V1.30859ZM16.9938 8.78516H5.0062V7.23828H16.9938V8.78516ZM5.0062 10.0742H16.9938V11.6211H5.0062V10.0742ZM5.0062 12.9102H16.9938V14.457H5.0062V12.9102ZM5.0062 15.7461H16.9938V20.7305H5.0062V15.7461ZM19.7007 20.7305H18.2829V5.94922H3.71713V20.7305H2.29933V4.53612H19.7007V20.7305Z" class="icon-fill"/>
  </svg>


</template>

<script>
export default {
  name: 'storage'
}
</script>
<style lang="css">
.icon-fill {
  fill: currentColor;
}
</style>